"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OUT_SCENE_EFFECT = exports.IN_SCENE_EFFECT = exports.CONTENT_POSITION = exports.OPACITY_LAYOUT_COLORS = void 0;
/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// React
const react_1 = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const prop_types_1 = __importDefault(require("prop-types"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
// genero version
// Enums and Utils
const enums_1 = require("./enums");
Object.defineProperty(exports, "CONTENT_POSITION", { enumerable: true, get: function () { return enums_1.CONTENT_POSITION; } });
Object.defineProperty(exports, "IN_SCENE_EFFECT", { enumerable: true, get: function () { return enums_1.IN_SCENE_EFFECT; } });
Object.defineProperty(exports, "OPACITY_LAYOUT_COLORS", { enumerable: true, get: function () { return enums_1.OPACITY_LAYOUT_COLORS; } });
Object.defineProperty(exports, "OUT_SCENE_EFFECT", { enumerable: true, get: function () { return enums_1.OUT_SCENE_EFFECT; } });
const utils_1 = require("./utils");
// Identifies the root for the Portal
let modalRoot = null;
class Modal extends react_1.Component {
    constructor(props) {
        super(props);
        this.createContentCss = (contentPosition, inSceneEffect, outSceneEffect, show, className) => {
            const arrayContentPosition = contentPosition && contentPosition.split('--');
            const isCustom = Array.isArray(arrayContentPosition) &&
                arrayContentPosition.length > 0 &&
                arrayContentPosition[0] === enums_1.CONTENT_POSITION.CUSTOM;
            let cssContentPosition = '';
            let customPosition = {};
            let currentContentPosition = contentPosition;
            if (isCustom) {
                cssContentPosition = 'Modal_content Modal_content--custom';
                currentContentPosition = 'custom';
                if (arrayContentPosition.length > 3) {
                    const positionX = arrayContentPosition[1];
                    const positionY = arrayContentPosition[2];
                    const currentTransform = arrayContentPosition[3];
                    customPosition = {
                        top: `${positionY}`,
                        left: `${positionX}`,
                        transform: currentTransform,
                    };
                }
            }
            else {
                cssContentPosition = contentPosition
                    ? `Modal_content Modal_content--${contentPosition}`
                    : '';
            }
            let sceneCss = inSceneEffect
                ? ` Modal_content--${currentContentPosition}--${inSceneEffect}`
                : '';
            if (!show) {
                sceneCss = outSceneEffect
                    ? ` Modal_content--${currentContentPosition}--${outSceneEffect}`
                    : '';
            }
            const cssOwnClassName = className ? ` ${className}` : '';
            return {
                contentCss: `${cssContentPosition}${sceneCss}${cssOwnClassName}`,
                customPosition,
            };
        };
        this.createOpacityLayoutCss = (opacityLayoutColor, show) => {
            return ((show &&
                `Single_Modal opacity_layout opacity_layout--${opacityLayoutColor} Single_Modal--fadeIn`) ||
                `Single_Modal opacity_layout opacity_layout--${opacityLayoutColor} Single_Modal--fadeOut`);
        };
        this.handleCloseOnLayout = () => {
            const { reduxDispatchActions } = this.props;
            const { closeByClickingOutside, onCloseHandler, closeByClickingOutsideParams, } = this.state;
            if (closeByClickingOutside) {
                if (!reduxDispatchActions) {
                    Modal.__singletonRef.hide();
                }
                if (reduxDispatchActions) {
                    reduxDispatchActions(closeByClickingOutsideParams);
                }
                if (onCloseHandler) {
                    onCloseHandler();
                }
            }
        };
        this.setModalRoot = (projectId) => {
            if (projectId) {
                const appDiv = document.getElementById(projectId);
                if (appDiv) {
                    modalRoot = appDiv.getElementsByClassName('modal-root');
                    if (modalRoot && modalRoot.length > 0) {
                        [modalRoot] = modalRoot;
                    }
                    else {
                        modalRoot = document.getElementById('modal-root');
                    }
                }
            }
            else {
                modalRoot = document.getElementById('modal-root');
            }
        };
        this.setScrollOnElements = (scrollValue) => {
            const body = document.getElementsByTagName('body')[0];
            const html = document.getElementsByTagName('html')[0];
            body.style.overflowY = scrollValue;
            html.style.overflowY = scrollValue;
        };
        this.renderModalContent = (contentInsideContainer, content, contentCss, customPosition) => {
            if (contentInsideContainer) {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "xux" },
                        react_1.default.createElement("div", { className: "container" },
                            react_1.default.createElement("div", { className: `${contentCss}`, style: customPosition }, content)))));
            }
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: `${contentCss}`, style: customPosition }, content)));
        };
        const { projectId } = props;
        if (typeof window !== 'undefined' && !modalRoot) {
            this.setModalRoot(projectId);
            Modal.__singletonRef = this;
        }
        const { opacityLayoutColor, contentPosition, className, inSceneEffect, outSceneEffect, closeByClickingOutside, taggingInfoWhenClickingOutside, contentInsideContainer, scrollAllowed, onCloseHandler, closeByClickingOutsideParams, } = props;
        this.state = {
            unMounted: true,
            show: false,
            className,
            inSceneEffect,
            outSceneEffect,
            contentPosition,
            opacityLayoutColor,
            closeByClickingOutside,
            taggingInfoWhenClickingOutside,
            contentInsideContainer,
            scrollAllowed,
            onCloseHandler,
            closeByClickingOutsideParams,
        };
    }
    static show() {
        Modal.__singletonRef.__show();
    }
    static hide() {
        Modal.__singletonRef.__hide();
    }
    static setContent(component) {
        Modal.__singletonRef.__setContent(component);
    }
    static setModalProps(props) {
        Modal.__singletonRef.__setModalProps(props);
    }
    /* this handle transition and unmounted event */
    componentDidUpdate() {
        const { show, unMounted } = this.state;
        if (!show && !unMounted) {
            const transitionEvent = (0, utils_1.whichAnimationEvent)();
            const element = document.getElementById('animationReference');
            if (transitionEvent) {
                element.addEventListener(transitionEvent, () => {
                    // hide modal root
                    modalRoot.classList.remove('visible');
                    this.setState({ unMounted: true });
                });
            }
        }
    }
    __setContent(content) {
        this.setState({ content });
    }
    __setModalProps(props) {
        const { scrollAllowed, show } = props;
        if (scrollAllowed) {
            this.setScrollOnElements('auto');
        }
        if (typeof show !== 'undefined' && show) {
            this.__show();
        }
        if (typeof show !== 'undefined' && !show) {
            this.__hide();
        }
        this.setState(Object.assign({}, props));
    }
    __show() {
        const { scrollAllowed } = this.state;
        // show modal-root
        modalRoot.classList.add('visible');
        // disallow scroll on html,body
        if (!scrollAllowed) {
            this.setScrollOnElements('hidden');
        }
        else {
            this.setScrollOnElements('auto');
        }
        // set properties
        this.setState({ show: true, unMounted: false });
    }
    __hide() {
        // disallow scroll on html,body
        this.setScrollOnElements('auto');
        this.setState({ show: false });
    }
    render() {
        const { opacityLayoutColor, contentPosition, className, inSceneEffect, outSceneEffect, unMounted, contentInsideContainer, taggingInfoWhenClickingOutside, } = this.state;
        const { show, content } = this.state;
        const cssOpaticyLayout = this.createOpacityLayoutCss(opacityLayoutColor, show);
        const { contentCss, customPosition } = this.createContentCss(contentPosition, inSceneEffect, outSceneEffect, show, className);
        if ((!show && unMounted) || !content) {
            return null;
        }
        return react_dom_1.default.createPortal(react_1.default.createElement(react_1.default.Fragment, null,
            this.renderModalContent(contentInsideContainer, content, contentCss, customPosition),
            taggingInfoWhenClickingOutside && (react_1.default.createElement(next_components_custom_link_1.default, { id: "animationReference", className: cssOpaticyLayout, taggingInfo: taggingInfoWhenClickingOutside, onClick: this.handleCloseOnLayout })),
            !taggingInfoWhenClickingOutside && (react_1.default.createElement(next_components_custom_link_1.default, { id: "animationReference", role: "button", tabIndex: "-1", className: cssOpaticyLayout, onClick: this.handleCloseOnLayout }))), modalRoot);
    }
}
Modal.propTypes = {
    /**
     * {
     *  "info": "Define la clase CSS custom que se aplicará al componente",
     *  "kind": "both",
     *  "beautifulName": "Estilos custom"
     * }
     */
    className: prop_types_1.default.string,
    /**
     * {
     *  "info": "Establece si la modal puede ser cerrada al hacer click fuera de ella",
     *  "kind": "both",
     *  "beautifulName": "Cerrar con click fuera"
     * }
     */
    closeByClickingOutside: prop_types_1.default.bool,
    /**
     * {
     *  "info": "Establece si la modal puede ser cerrada al hacer click fuera de ella",
     *  "kind": "both",
     *  "beautifulName": "Cerrar con click fuera"
     * }
     */
    taggingInfoWhenClickingOutside: prop_types_1.default.object,
    /**
     * {
     *  "info": "Define la posición que ocupará la modal al ser lanzada",
     *  "kind": "both",
     *  "beautifulName": "Posición"
     * }
     */
    contentPosition: prop_types_1.default.oneOf([
        enums_1.CONTENT_POSITION.CENTER_CENTER,
        enums_1.CONTENT_POSITION.CENTER_TOP,
        enums_1.CONTENT_POSITION.RIGHT_TOP,
        enums_1.CONTENT_POSITION.LEFT_TOP,
        enums_1.CONTENT_POSITION.CENTER_BOTTOM,
    ]),
    /**
     * {
     *  "info": "Define el color de background de la capa layout que cubre la pantalla bajo la modal",
     *  "kind": "both",
     *  "beautifulName": "Estilos layout"
     * }
     */
    opacityLayoutColor: prop_types_1.default.oneOf([
        enums_1.OPACITY_LAYOUT_COLORS.BLACK,
        enums_1.OPACITY_LAYOUT_COLORS.WHITE,
        enums_1.OPACITY_LAYOUT_COLORS.DARKBLUE,
        enums_1.OPACITY_LAYOUT_COLORS.BLACK05,
        enums_1.OPACITY_LAYOUT_COLORS.TRANSPARENT,
    ]),
    /**
     * {
     *  "info": "Define el efecto con el que se mostrará la modal al ser lanzada",
     *  "kind": "both",
     *  "beautifulName": "Efecto de apertura"
     * }
     */
    inSceneEffect: prop_types_1.default.oneOf([
        enums_1.IN_SCENE_EFFECT.FADE_IN,
        enums_1.IN_SCENE_EFFECT.FADE_IN_LEFT,
        enums_1.IN_SCENE_EFFECT.FADE_IN_RIGHT,
        enums_1.IN_SCENE_EFFECT.FADE_IN_TOP,
        enums_1.IN_SCENE_EFFECT.FADE_IN_BOTTOM,
    ]),
    /**
     * {
     *  "info": "Define el efecto con el que se ocultará la modal al ser cerrada",
     *  "kind": "both",
     *  "beautifulName": "Efecto de cierre"
     * }
     */
    outSceneEffect: prop_types_1.default.oneOf([
        enums_1.OUT_SCENE_EFFECT.FADE_OUT,
        enums_1.OUT_SCENE_EFFECT.FADE_OUT_LEFT,
        enums_1.OUT_SCENE_EFFECT.FADE_OUT_RIGHT,
        enums_1.OUT_SCENE_EFFECT.FADE_OUT_BOTTOM,
        enums_1.OUT_SCENE_EFFECT.FADE_OUT_TOP,
    ]),
    /**
     * {
     *  "info": "Define si la modal se tiene que mostrar dentro del elemento container de la página o fuera de el",
     *  "kind": "both",
     *  "beautifulName": "Dentro de container"
     * }
     */
    contentInsideContainer: prop_types_1.default.bool,
    /**
     * {
     *  "info": "Define si la modal permite scroll",
     *  "kind": "both",
     *  "beautifulName": "Scrollable"
     * }
     */
    scrollAllowed: prop_types_1.default.bool,
    /**
     * {
     *  "info": "Método que se ejecuta al hacer click fuera del modal",
     *  "kind": "both",
     *  "beautifulName": "Método de cierre"
     * }
     */
    onCloseHandler: prop_types_1.default.func,
    /**
     * {
     *  "info": "parametros para redefinir los parametros de la funcion de cierre clicando fuera del modal",
     *  "kind": "both",
     *  "beautifulName": "parametros de la funcion de cierre"
     * }
     */
    closeByClickingOutsideParams: prop_types_1.default.object,
};
Modal.defaultProps = {
    className: '',
    closeByClickingOutside: false,
    taggingInfoWhenClickingOutside: null,
    contentPosition: enums_1.CONTENT_POSITION.CENTER_BOTTOM,
    opacityLayoutColor: enums_1.OPACITY_LAYOUT_COLORS.BLACK,
    inSceneEffect: enums_1.IN_SCENE_EFFECT.FADE_IN,
    outSceneEffect: enums_1.OUT_SCENE_EFFECT.FADE_OUT,
    contentInsideContainer: false,
    scrollAllowed: false,
    onCloseHandler: null,
    closeByClickingOutsideParams: {
        id: '',
        type: 'MODAL',
    },
};
exports.default = Modal;
//# sourceMappingURL=index.js.map